// Shared formatting helpers. Dates are rendered as mm/dd/yyyy (en-US).

export const fmtDate = (d) =>
  new Date(d).toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" });

export const fmtTime = (d) =>
  new Date(d).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });

export const fmtDateTime = (d) => `${fmtDate(d)} ${fmtTime(d)}`;

// Backend range strings are ISO dates (YYYY-MM-DD); render without timezone shift.
export const fmtDateStr = (s) => {
  if (!s) return "";
  const [y, m, dd] = String(s).split("T")[0].split("-");
  return `${m}/${dd}/${y}`;
};

// Distance unit conversion (stored radius is in the company's chosen unit).
export const UNIT_METERS = { feet: 0.3048, miles: 1609.344, meters: 1, kilometers: 1000 };
export const UNIT_ABBR = { feet: "ft", miles: "mi", meters: "m", kilometers: "km" };
export const toUnit = (meters, unit) => Math.round(meters / (UNIT_METERS[unit] || 1));
